import base from './base';
import data from './data/main';

const mainApi = {};

mainApi.getPointThumbnailList = () => {
  return base.fetch(data.pointThumbnailList, 300);
};

mainApi.getPointList = () => {
  return base.fetch(data.pointList, 300);
};

export default {
  ...mainApi,
};
